import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const _frontmatter = {
  "title": "Offshore Oil & Gas | How revenue works",
  "description": "The Outer Continental Shelf Lands Act (OCSLA) of 1953 grants the Secretary of the Department of the Interior (DOI) the authority to manage offshore energy resources and to develop regulations to carry out that authority. Three agencies within DOI — BOEM, BSEE, and ONRR — work together to manage, regulate, and collect revenue from leased acres across the Outer Continental Shelf.",
  "includeToc": false,
  "tags": ["How revenue works", "Offshore", "Oil", "Gas", "Process", "Resources"]
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageTabs = makeShortcode("PageTabs");
const PageTab = makeShortcode("PageTab");
const Box = makeShortcode("Box");
const Container = makeShortcode("Container");
const Grid = makeShortcode("Grid");
const GlossaryTerm = makeShortcode("GlossaryTerm");
const BoemLogoImg = makeShortcode("BoemLogoImg");
const BseeLogoImg = makeShortcode("BseeLogoImg");
const OnrrLogoImg = makeShortcode("OnrrLogoImg");
const OffshoreOilGasBackground = makeShortcode("OffshoreOilGasBackground");
const DidYouKnowCard = makeShortcode("DidYouKnowCard");
const CollapsibleContent = makeShortcode("CollapsibleContent");
const ProcessCard = makeShortcode("ProcessCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageTabs mdxType="PageTabs">
  <PageTab mdxType="PageTab">
    Offshore
  </PageTab>
  <PageTab alt={'Navigate to Onshore Oil and Gas'} to={'/how-revenue-works/onshore-oil-gas/'} mdxType="PageTab">
    Onshore
  </PageTab>
    </PageTabs>
    <Box bgcolor='primary.main' mdxType="Box">
      <Container maxWidth="lg" mdxType="Container">
        <Grid container alignItems='center' mdxType="Grid">
          <Grid item xs={12} sm={8} mdxType="Grid">
            <Box p={3} pl={0} mdxType="Box">
              <p><a parentName="p" {...{
                  "href": "/sites/December-23-Uploads/how-revenue-works/"
                }}>{`How revenue works /`}</a></p>

              <h1 {...{
                "id": "Offshore-Oil--Gas",
                "style": {
                  "position": "relative"
                }
              }}>{`Offshore Oil & Gas`}</h1>
              <p>{`The Outer Continental Shelf Lands Act (OCSLA) of 1953 grants the Secretary of the Department of the Interior (DOI) the authority to manage offshore energy resources. OCSLA also authorizes DOI to develop regulations to carry out that authority. Within DOI, three agencies work toward that goal: BOEM, BSEE, and ONRR. These agencies work together to manage, regulate, and collect revenue from leased acres across the `}<GlossaryTerm mdxType="GlossaryTerm">{`Outer Continental Shelf`}</GlossaryTerm>{` (OCS).`}</p>
            </Box>
          </Grid>
          <Grid container xs={12} sm={4} mdxType="Grid">
            <Box p={3} border={4} borderTop={0} borderBottom={0} borderColor='white' mdxType="Box">
              <Grid container xs={12} mdxType="Grid">
                <Grid item xs={8} mdxType="Grid">
                  <p>{`Offshore oil and gas are managed and regulated by the `}<a parentName="p" {...{
                      "href": "http://www.boem.gov/"
                    }}>{`Bureau of Ocean Energy Management `}<OpenInNewIcon style={{
                        fontSize: 20
                      }} mdxType="OpenInNewIcon" /></a>{` (BOEM) and the `}<a parentName="p" {...{
                      "href": "http://www.bsee.gov/"
                    }}>{`Bureau of Safety and Environmental Enforcement `}<OpenInNewIcon style={{
                        fontSize: 20
                      }} mdxType="OpenInNewIcon" /></a>{` (BSEE).`}</p>
                </Grid>
                <Grid item xs={4} mdxType="Grid">
                  <Box p={4} mdxType="Box"><BoemLogoImg mdxType="BoemLogoImg"></BoemLogoImg></Box>
                  <Box p={4} pt={0} mdxType="Box"><BseeLogoImg mdxType="BseeLogoImg"></BseeLogoImg></Box>
                </Grid>
                <Grid item xs={8} mdxType="Grid">
                  <p>{`The `}<a parentName="p" {...{
                      "href": "http://www.onrr.gov/"
                    }}>{`Office of Natural Resources Revenue `}<OpenInNewIcon style={{
                        fontSize: 20
                      }} mdxType="OpenInNewIcon" /></a>{` (ONRR) manages monetary transactions.`}</p>
                </Grid>
                <Grid item xs={4} mdxType="Grid">
                  <Box p={4} mdxType="Box"><OnrrLogoImg mdxType="OnrrLogoImg"></OnrrLogoImg></Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
    <OffshoreOilGasBackground mdxType="OffshoreOilGasBackground">
      <Grid container spacing={2} alignItems='flex-start' mdxType="Grid">
        <Grid item xs={12} sm={4} mdxType="Grid">
          <Box p={9} m={9} display={{
            xs: 'none',
            sm: 'block'
          }} mdxType="Box" />
          <Box p={8} display={{
            xs: 'block',
            sm: 'none'
          }} mdxType="Box" />
          <DidYouKnowCard mdxType="DidYouKnowCard">
            <p>{`The Gulf of Mexico Energy Security Act of 2006 (GOMESA) changed the leasing program for extracting oil and gas on the Outer Continental Shelf (OCS).`}</p>
            <CollapsibleContent mdxType="CollapsibleContent">
              <p>{`GOMESA:`}</p>
              <ul>
                <li parentName="ul">{`Opens 8.6 million acres in the Gulf of Mexico for oil and gas leasing.`}</li>
                <li parentName="ul">{`Stipulates that 37.5% of all qualified OCS revenue will be shared among the states of Alabama, Louisiana, Mississippi, and Texas. It also stipulates that 12.5% of revenue will be allocated to the Land and Water Conservation Fund. (Revenue from a more substantial set of leases was added in 2017.)`}</li>
                <li parentName="ul">{`Bans oil and gas leasing within 125 miles of the Florida coastline in the Eastern Planning Area, and within a portion of the Central Planning Area, until 2022.`}</li>
                <li parentName="ul">{`Allows companies to exchange certain existing leases in moratorium areas for bonus and royalty credits to be used on other Gulf of Mexico leases.`}</li>
              </ul>
            </CollapsibleContent>
          </DidYouKnowCard>
        </Grid>
        <Grid item xs={12} sm={1} mdxType="Grid">
        </Grid>
        <Grid item xs={12} sm={7} mdxType="Grid">
          <Box mt={5} mdxType="Box">
            <ProcessCard step={1} name={'Plan'} mdxType="ProcessCard">
              <p>{`Under the 1978 OCSLA amendment, BOEM develops a schedule of planning areas across the Outer Continental Shelf for oil and gas leasing. This program is known as the Five-Year Outer Continental Shelf Leasing Program. The program aims to address national energy needs while balancing economic, environmental, and social considerations.`}</p>
              <br />
BOEM creates an <GlossaryTerm mdxType="GlossaryTerm">Environmental Impact Statement (EIS)</GlossaryTerm> to implement the program. The public may comment on the Environmental Impact Statement and the proposed leasing program. BOEM submits public comments for the program and plan to Congress and the President.
            </ProcessCard>
            <ProcessCard step={2} name={'Lease'} mdxType="ProcessCard">
              <p>{`Once the Five-Year Program is in place, BOEM plans for each regional lease sale. This is a one-to-two-year process that includes developing site-specific Environmental Impact Statements and offering opportunities for public comment. BOEM will send a notice of sale to interested bidders. The notice of sale contains the terms and conditions of the “blocks,” the nine-square-mile areas offered in the lease sale.`}</p>
              <br />
              <p>{`BOEM offers leases through a competitive process that anyone can participate in by submitting a sealed bid. BOEM reviews the bids and identifies the winner (the bidder with the highest offer). The winner will receive the lease if their bid is greater than or equal to BOEM’s `}<GlossaryTerm mdxType="GlossaryTerm">{`fair market value`}</GlossaryTerm>{` estimate. BOEM calculates the fair market value estimate after identifying the winner. `}</p>
              <br />
              <p>{`Fair market value is based on the expected value of exploring for and extracting oil and gas resources from the lease block. Fair market value is not based on actual activities and discoveries resulting from the lease sale. Once BOEM accepts a bid and awards a lease, the lease holder must pay the `}<GlossaryTerm mdxType="GlossaryTerm">{`bonus`}</GlossaryTerm>{` and the first year’s rent to ONRR and satisfy any bonding requirements.`}</p>
              <br />
            </ProcessCard>
            <ProcessCard step={3} name={'Explore'} mdxType="ProcessCard">
              <p>{`During this phase, the lease holder must file an Exploration Plan with BOEM. An Exploration Plan allows the holder to explore the leased waters for oil and gas deposits. The plan must include timing, location of wells, method, and potential environmental impact for all exploration activities. This includes the potential environmental impact in the worst-case scenario. BOEM then evaluates the plan. BOEM determines if extenuating circumstances require the lease holder to complete a site-specific Environmental Assessment before proceeding.`}</p>
              <br />
              <p>{`Once a company begins exploring, they conduct geophysical surveys, drill to locate the oil or gas, and drill more wells after a discovery. Exploration can last five to ten years. During the explore phase, companies pay `}<GlossaryTerm mdxType="GlossaryTerm">{`rent`}</GlossaryTerm>{` to ONRR.`}</p>
            </ProcessCard>
            <ProcessCard step={4} name={'Develop'} mdxType="ProcessCard">
              <p>{`Before extracting resources, the lease holder must submit a Development or Production Plan for BOEM’s approval. The lease holder must also apply to BSEE for drilling and operations permits to begin extraction. At the start of development, BSEE will conduct initial inspections. Initial inspections ensure the proper installation of structures and equipment. Thereafter, BSEE conducts periodic announced and unannounced inspections.  These inspections enforce lease terms and other conditions.`}</p>
              <br />
              <p>{`The lease holder pays annual rent until the operation starts producing oil or gas. At that time, the lease holder stops paying rent and starts paying `}<GlossaryTerm mdxType="GlossaryTerm">{`royalties`}</GlossaryTerm>{` to ONRR.`}</p>
            </ProcessCard>
            <ProcessCard step={5} name={'Decommission and reclaim'} mdxType="ProcessCard">
              <p>{`At the close of an operation, the lease holder or operator must return the ocean and seafloor to its pre-lease condition. Under the OCSLA regulations, the lease holder is required to submit a Decommissioning Plan to BSEE for approval. This plan must be submitted two years before the termination of the lease. To meet the National Environmental Policy Act (NEPA) obligations, BOEM prepares a site-specific Environmental Assessment for each removal application on behalf of BSEE.`}</p>
              <br />
              <p>{`BOEM requires that companies remove retired offshore drilling platforms from the marine environment within one year after the end of an operation. The lease holder must remove the platform from its foundation by severing all bottom-founded components at least 15 feet below the mudline. The lease holder must then dispose of the structures in a scrap or fabrication yard. Alternatively, the platform can be used to create an artificial reef underwater.`}</p>
              <br />
              <p>{`Lease holders post bonds to ensure compliance with lease terms. This includes decommissioning the site. If the lease holder fails to decommission the site, the government may use the bonds to cover the cost of decommissioning. If the lease holder complies, the government returns the bonds to the lease holder at the end of the operation.`}</p>
              <br />
            </ProcessCard>
            <ProcessCard name={'Rates and fees'} defaultExpanded={true} mdxType="ProcessCard">
              <ul>
                <li parentName="ul"><a parentName="li" {...{
                    "href": "/sites/December-23-Uploads/how-revenue-works/revenues/#Oil-and-gas"
                  }}>{`Oil and gas rates and fees`}</a></li>
              </ul>
            </ProcessCard>
            <ProcessCard name={'Learn more'} defaultExpanded={true} mdxType="ProcessCard">
              <ul>
                <li parentName="ul"><a parentName="li" {...{
                    "href": "https://www.boem.gov/sites/default/files/uploadedFiles/BOEM/Oil_and_Gas_Energy_Program/Leasing/5BOEMRE_Leasing101.pdf"
                  }}>{`Oil and gas leasing on the Outer Continental Shelf (PDF) `}<OpenInNewIcon style={{
                      fontSize: 20
                    }} mdxType="OpenInNewIcon" /></a></li>
                <li parentName="ul"><a parentName="li" {...{
                    "href": "https://www.boem.gov/oil-gas-energy/resource-evaluation"
                  }}>{`Resource Evaluation Glossary `}<OpenInNewIcon style={{
                      fontSize: 20
                    }} mdxType="OpenInNewIcon" /></a></li>
              </ul>
            </ProcessCard>
          </Box>
        </Grid>
      </Grid>
    </OffshoreOilGasBackground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      